/** Mirrors backend markSelectedIngredients (server.js) — sets isActive per option
 *  against a list of selected ingredient ids.
 *
 *  "No Sauce"/"No Starch" carry `id: null` and would both match the same entry in
 *  a shared id list, so `selectNone` opts into them one category at a time. */
export function markActiveOptions(options = [], selectedIds = [], selectNone = false) {
  return (options || []).map((opt) => ({
    ...opt,
    isActive: opt.id == null ? Boolean(selectNone) : selectedIds.includes(opt.id),
  }));
}

/** Single-select substitution (protein/sauce/starch): mark only newId active,
 *  strip all same-category ids from finalIngredients, append newId. */
export function replaceSingleSelect(options, finalIngredients, newId, oldId) {
  const updatedOptions = (options || []).map((opt) => ({
    ...opt,
    isActive: opt.id === newId,
  }));

  const allCategoryIds = (options || []).map((opt) => opt.id);
  let updatedFinalIngredients = (finalIngredients || []).filter(
    (ing) => !allCategoryIds.includes(ing.id),
  );
  if (newId) {
    const newOption = (options || []).find((opt) => opt.id === newId);
    updatedFinalIngredients = [
      ...updatedFinalIngredients,
      // The allergen links come along so the ingredient can still be judged
      // against a different member's allergies later.
      { id: newId, name: newOption?.name || '', allergen: newOption?.allergen || [] },
    ];
  }

  return { updatedOptions, updatedFinalIngredients };
}

/** Multi-select toggle (veggie/garnish): flip isActive for targetId only,
 *  add/remove targetId from finalIngredients. */
export function toggleMultiSelect(options, finalIngredients, targetId, isCurrentlyActive) {
  const targetOption = (options || []).find((opt) => opt.id === targetId);

  const updatedOptions = (options || []).map((opt) => ({
    ...opt,
    isActive: opt.id === targetId ? !isCurrentlyActive : opt.isActive,
  }));

  let updatedFinalIngredients = [...(finalIngredients || [])];
  if (isCurrentlyActive) {
    updatedFinalIngredients = updatedFinalIngredients.filter((ing) => ing.id !== targetId);
  } else if (!updatedFinalIngredients.some((ing) => ing.id === targetId)) {
    updatedFinalIngredients = [
      ...updatedFinalIngredients,
      { id: targetId, name: targetOption?.name || '', allergen: targetOption?.allergen || [] },
    ];
  }

  return { updatedOptions, updatedFinalIngredients };
}
